<template>
  <section id="lojas" class="lista">
    <div class="conteudo">
      <h2 class="lista__titulo">Encontramos para você</h2>

      <p v-if="mensagemDeErro" class="lista__erro" role="alert">{{ mensagemDeErro }}</p>

      <CarregandoCatalogo v-if="carregando" :mensagem="textos.carregando" />

      <template v-else>
        <p class="lista__contagem" aria-live="polite">
          {{ itens.length }} {{ itens.length === 1 ? textos.encontradoSingular : textos.encontradoPlural }}
        </p>

        <FiltroDeCategorias
          :categorias="categoriasDeProduto"
          :selecionada="categoriaSelecionada"
          @selecionar="emit('selecionar-categoria', $event)"
        />

        <div v-if="itens.length" class="lista__grade">
          <CartaoDoCatalogo v-for="item in itens" :key="item.id" :item="item" />
        </div>

        <PaginacaoDaListagem
          v-if="itens.length"
          :pagina="pagina"
          :paginas-conhecidas="paginasConhecidas"
          @ir="emit('ir-para-pagina', $event)"
        />

        <div v-else class="lista__vazio">
          <p class="lista__vazio-titulo">{{ textos.vazio }}</p>
          <p class="lista__vazio-texto">Tente outra categoria ou busque por outro nome.</p>
          <button v-if="possuiFiltrosAtivos" type="button" class="lista__vazio-acao" @click="emit('limpar')">
            {{ textos.acaoVazio }}
          </button>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup>
  import { computed } from 'vue';
  import CartaoDoCatalogo from '@/components/marketplace/CartaoDoCatalogo.vue';
  import FiltroDeCategorias from '@/components/marketplace/FiltroDeCategorias.vue';
  import CarregandoCatalogo from '@/components/marketplace/CarregandoCatalogo.vue';
  import PaginacaoDaListagem from '@/components/marketplace/PaginacaoDaListagem.vue';

  const TEXTOS_POR_RECURSO = {
    products: {
      carregando: 'Buscando produtos...',
      encontradoSingular: 'produto encontrado',
      encontradoPlural: 'produtos encontrados',
      vazio: 'Nenhum produto encontrado.',
      acaoVazio: 'Ver todos os produtos'
    },
    shops: {
      carregando: 'Buscando lojas...',
      encontradoSingular: 'loja encontrada',
      encontradoPlural: 'lojas encontradas',
      vazio: 'Nenhuma loja encontrada.',
      acaoVazio: 'Ver todas as lojas'
    }
  };

  const props = defineProps({
    itens: {
      type: Array,
      default: () => []
    },
    recurso: {
      type: String,
      default: 'shops'
    },
    carregando: {
      type: Boolean,
      default: false
    },
    pagina: {
      type: Number,
      default: 1
    },
    paginasConhecidas: {
      type: Number,
      default: 1
    },
    mensagemDeErro: {
      type: String,
      default: ''
    },
    possuiFiltrosAtivos: {
      type: Boolean,
      default: false
    },
    categoriasDeProduto: {
      type: Array,
      default: () => []
    },
    categoriaSelecionada: {
      type: String,
      default: ''
    }
  });

  const emit = defineEmits(['limpar', 'selecionar-categoria', 'ir-para-pagina']);

  const textos = computed(() => TEXTOS_POR_RECURSO[props.recurso] || TEXTOS_POR_RECURSO.shops);
</script>

<style scoped>
  .lista {
    padding-block: var(--espaco-6) var(--espaco-7);
  }

  .lista__titulo {
    font-size: 1.3rem;
    font-weight: 700;
    color: var(--cor-tinta);
  }

  .lista__contagem {
    margin: var(--espaco-2) 0 var(--espaco-4);
    font-size: 0.82rem;
    color: var(--cor-texto-tenue);
  }

  .lista__erro {
    margin: 0 0 var(--espaco-4);
    padding: var(--espaco-3) var(--espaco-4);
    border-radius: var(--raio-medio);
    background: var(--cor-marca-clara);
    color: var(--cor-marca-escura);
    font-size: 0.86rem;
  }

  .lista__grade {
    display: grid;
    gap: var(--espaco-3);
  }

  .lista__vazio {
    padding: var(--espaco-7) var(--espaco-4);
    text-align: center;
    border: 1.5px dashed var(--cor-linha);
    border-radius: var(--raio-grande);
  }

  .lista__vazio-titulo {
    margin: 0 0 var(--espaco-2);
    font-family: var(--fonte-titulo);
    font-size: 1.06rem;
    font-weight: 700;
    color: var(--cor-tinta);
  }

  .lista__vazio-texto {
    margin: 0 0 var(--espaco-4);
    font-size: 0.88rem;
    color: var(--cor-texto-suave);
  }

  .lista__vazio-acao {
    padding: var(--espaco-3) var(--espaco-5);
    border-radius: var(--raio-pilula);
    background: var(--cor-marca);
    color: #fff;
    font-weight: 700;
    font-size: 0.85rem;
    transition: background var(--transicao-padrao);
  }

  .lista__vazio-acao:hover {
    background: var(--cor-marca-escura);
  }

  @media (min-width: 768px) {
    .lista__titulo {
      font-size: 1.5rem;
    }

    .lista__grade {
      grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
      gap: var(--espaco-4);
    }
  }
</style>
